
// Declare Constants
const QRTokenQueryKey = 'access_token';
const OIDCTokenQueryKey = 'access_token_v2';
const BizAccessTokenQueryKey = 'x_business_web_login_token';
const RocketChatWebClientVersionQueryKey = "x-rocketchat-web-client-version";

// Declare authentication interface
type Authentication = QRAccessToken | BizAccessToken | OIDCAccessToken

type QRAccessToken = {
  qrToken: string
}

type BizAccessToken = {
  bizToken: string
}

type OIDCAccessToken = {
  accessToken: string
}

const encode = (obj: Record<string, string>) => new URLSearchParams({ ...obj }).toString();
export const encodeAuthentication = (authentication: Authentication) => {
  if ('qrToken' in authentication) {
    return encode({ [QRTokenQueryKey]: authentication.qrToken });
  }

  if ('bizToken' in authentication) {
    return encode({ [BizAccessTokenQueryKey]: authentication.bizToken });
  }

  if ('accessToken' in authentication) {    
    return encode({ [OIDCTokenQueryKey]: authentication.accessToken, [RocketChatWebClientVersionQueryKey]: "99.99.99" });
  }

  throw new Error('Invalid authentication');
};

export const isOIDCAccessToken = (authentication: Authentication): authentication is OIDCAccessToken => {
  return 'accessToken' in authentication;
};

export const isBizAccessToken = (authentication: Authentication): authentication is BizAccessToken => {
  return 'bizToken' in authentication;
};

export const isQRAccessToken = (authentication: Authentication): authentication is QRAccessToken => {
  return 'qrToken' in authentication;
};

export type { Authentication };
